/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./gifts.vue?vue&type=template&id=38b3c56d&scoped=true"
import script from "./gifts.vue?vue&type=script&lang=js"
export * from "./gifts.vue?vue&type=script&lang=js"
import style0 from "./gifts.vue?vue&type=style&index=0&id=38b3c56d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3c56d",
  null
  
)

export default component.exports